/**
 * Comment DTOs — internal team comments on a feedback session. Org-scoped and
 * authored by an authenticated admin (never shown to the end user).
 */
import type { z } from 'zod';
import { array, iso, object, string } from 'zod';

/** Body for creating an internal comment. */
export const CreateCommentSchema = object({
  body: string().min(1).max(16384),
  /** Mentioned user ids (for notifications). */
  mentions: array(string().min(1)).max(50).default([]),
});
export type CreateComment = z.infer<typeof CreateCommentSchema>;

/** A persisted internal comment. */
export const CommentSchema = object({
  id: string().min(1),
  sessionId: string().min(1),
  authorUserId: string().min(1),
  body: string(),
  mentions: array(string()).default([]),
  /** Denormalized author display fields for the dashboard (optional). */
  authorName: string().nullable().optional(),
  authorEmail: string().nullable().optional(),
  createdAt: iso.datetime(),
});
export type Comment = z.infer<typeof CommentSchema>;
